import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { ModalComponent } from "../../modules/modal/modal.component";
import { ModalHeaderComponent } from "../../modules/modal/modal.header.component";
import { S25ModalModule } from "../../modules/s25-modal/s25.modal.module";

@Component({
    selector: "s25-ng-recommended-browsers",
    host: {
        class: "s25-ng",
    },
    template: `
        <s25-modal-header [data]="params()"></s25-modal-header>
        <div class="modal-body ngCenterAlignText">
            @if (data.isUnsupportedBrowser) {
                <div>
                    <strong>Use of Internet Explorer Is no Longer Officially Supported (as of August 20, 2020)</strong>
                    <p>
                        Please upgrade to Microsoft's official browser, Microsoft Edge, the official recommended browser
                        for Windows, or one of the other supported browsers listed below.
                    </p>
                    <p>25Live works best and fastest in Google Chrome, Microsoft Edge, and Mozilla Firefox.</p>
                </div>
            }
            <p></p>
            <div>
                <span
                    >25Live works best and fastest in
                    <a href="http://www.google.com/chrome/" target="chrome">Google Chrome</a>,
                    <a href="https://www.microsoft.com/edge" target="edge">Microsoft Edge</a>, and
                    <a href="http://www.firefox.com/" target="firefox">Mozilla Firefox</a>.
                </span>
            </div>
            <br />
            <p aria-hidden="true">
                <a href="http://www.google.com/chrome/" target="chrome" aria-label="Google Chrome"
                    ><span class="ngChrome ngInlineBlock"></span
                ></a>
                <a href="https://www.microsoft.com/edge" target="edge" aria-label="Microsoft Edge"
                    ><span class="ngEdge ngInlineBlock"></span
                ></a>
                <a href="http://www.firefox.com/" target="firefox" aria-label="Mozilla Firefox"
                    ><span class="ngFirefox ngInlineBlock"></span
                ></a>
            </p>
        </div>
        <s25-ng-modal-footer [type]="'close'" (affirm)="params()?.closeModal()" />
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalHeaderComponent, S25ModalModule],
})
export class RecommendedBrowsersModalComponent extends ModalComponent<{ isUnsupportedBrowser: boolean }> {
    static readonly size = "lg";
    static readonly title = "Browser Recommendations";
    static readonly iconClass = "ng25Live";
}
